import React from 'react';
import Icon, { IconType } from '../icon';
import * as css from './alert.module.scss';

export const Alert: React.FC<React.PropsWithChildren> = ({ children }) => (
  <h5 role="alert" className={css.alert}>
    <Icon type={IconType.Alert} />
    <span>{children}</span>
  </h5>
);
